// import useCurrentWeek from '@/hooks/useCurrentWeek';
// import { clamp } from '@CS/utils/Number';
// import API from '@/services/api';

const MAP_URL =
  'https://storage.googleapis.com/gg-prod-media/map/McD_HR_English_Week';

/**
 * Resolves the map video of the current campaign week, so that every game
 * released so far is reflected on the island.
 *
 * Weeks are counted from the start of the first game, one map per week, and
 * clamped to the available maps, as the campaign outlives its last game.
 *
 * @returns Map video URL without a file extension, e.g. `.../Week2`.
 */
export default (videos = Infinity): string => {
  // const firstGame = API.getCampaignGame(0);
  // const week = useCurrentWeek(firstGame);
  // return `${MAP_URL}${clamp(week, 1, videos)}`;

  // Use only one video for the whole campaign:
  return `${MAP_URL}${videos}`;
};
